import React, { useEffect, useState } from "react";
import Page from "../../components/Page";
import Steps from "../../components/Generales/Steps";
import { Row, Col, Card, CardBody, Button, Alert, } from "reactstrap";
import ComponentFormularioParametrico from "./ComponentFormularioParametrico";
import ComponentCoberturasParametrico from "./ComponentCoberturasParametrico";
import ComponentResumenParametrico from "./ComponentResumenParametrico";
import { ambienteAplicacion, controlador, urlConsultarIdentificacion, urlConsultarListaNegra, urlDefaultAux, urlObtenerInformacionInicialCP, urlPreguntasCotizadorParametrico, urlProcesoCotizadorParametrico, urlRecuperarCotizadorParametrico } from "../../constants/urls";
import { empresa } from "../../constants";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login.png";
import ComponentPreguntasParametrico from "./ComponentPreguntasParametrico";
import { useSelector } from "react-redux";
import moment from "moment";
import { apiPost, apiPost2 } from "../../api";



const ContainerCotizadorParametrico = (props) => {











    const [loading, setLoading] = useState(false)
    const [datosCotizador, setDatosCotizador] = useState(null);
    const [pasoActual, setPasoActual] = useState(null)
    const [tieneError, setTieneError] = useState(false)
    const [errorMensaje, setErrorMensaje] = useState('')
    const [planSeleccionado, setPlanSeleccionado] = useState(null)
    const [planes, setPlanes] = useState([])
    const [coberturas, setCoberturas] = useState([])
    const [productos, setProductos] = useState([])

    //constantes para recargos
    const [aplicaRecargos, setAplicaRecargos] = useState(false)
    const [aplicaObservaciones, setAplicaObservaciones] = useState(false)
    const [requiereObservacionObligatoria, setRequiereObservacionObligatoria] = useState(false);
    const [mensajeRecargos, setMensajeRecargos] = useState('¿Desea aplicar un recargo adicional sobre la prima neta?')
    const [mensajeObservaciones, setMensajeObservaciones] = useState('Desea incluir observaciones en la emisión de la póliza actual?')
    const [requiereRecargos, setRequiereRecargos] = useState(false)
    const [requiereObservacion, setRequiereObservacion] = useState(false)
    const [recargos, setRecargos] = useState([])
    const [recargoSeleccionado, setRecargoSeleccionado] = useState(null)
    const [recargoModificado, setRecargoModificado] = useState(false)
    const [observacion, setObservacion] = useState('')
    const [observacionValida, setObservacionValida] = useState(true)
    const [mensajeObservacion, setMensajeObservacion] = useState('')
    //fin constantes para recargos

    //constantes para control de duplicidad
    const [aplicaControlDuplicidad, setAplicaControlDuplicidad] = useState(false)
    const [placaDuplicada, setPlacaDuplicada] = useState(false)
    //fin constantes para control de duplicidad



    const [amparos, setAmparos] = useState(null)

    const [carritoActual, setCarritoActual] = useState(null)

    const [listaPasos, setListaPasos] = useState([])
    const [listaOpciones, setListaOpciones] = useState([])

    const queryParams = new URLSearchParams(props.location.search);
    const datosAsesor = useSelector((state) => state.datosUsuarios.dataUsuario)

    const [values, setValues] = useState({})
    const [preguntas, setPreguntas] = useState([])
    const [categorias, setCategorias] = useState([])
    const [obtenerPreguntas, setObtenerPreguntas] = useState(null)
    const [cargadoData, setCargadoData] = useState(false)
    const [valuesConTitulo, setValuesConTitulo] = useState({})

    const [idCarrito, setIdCarrito] = useState(queryParams.get('id') ? queryParams.get('id') : queryParams.get('idcarrito'));
    const [pasoParam, setPasoParam] = useState(queryParams.get('paso'))
    const [volverResumen, setVolverResumen] = useState(Boolean(queryParams.get('resumen')))
    const [datosCarrito, setDatosCarrito] = useState(null)

    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null)
    const [indiceSeleccionado, setIndiceSeleccionado] = useState(0)

    const [duplicado, setDuplicado] = useState(false)
    const [mensajeDuplicado, setMensajeDuplicado] = useState('')
    const [requiereEmisionRetroactiva, setRequiereEmisionRetroactiva] = useState(false)
    const [ramoNombre, setRamoNombre] = useState('')
    const [ramoCodigo, setRamoCodigo] = useState('')
    const [bloqueoListaNegra, setBloqueoListaNegra] = useState(false)
    const [mensajeListaNegra, setMensajeListaNegra] = useState('')

    useEffect(() => {
        obtenerDatosCotizador()

    }, [])

    useEffect(() => {
        if (listaPasos.length > 0) {
            if (idCarrito) {
                obtenerInformacionCarrito()
            }
        }
    }, [listaPasos, pasoActual])

    useEffect(() => {


        setCargadoData(false)
        window.scrollTo(0, 0);

        var pasoActualAux = null
        // setPasoActual(null)




        if (pasoParam && listaPasos.length > 0) {
            const opcionEncontrada = listaPasos.find(opcion => opcion.codigo == pasoParam)
            pasoActualAux = (opcionEncontrada)
        } else if (!pasoParam && !datosCarrito) {
            const opcionEncontrada = listaPasos.find(opcion => opcion.orden == 1)
            pasoActualAux = (opcionEncontrada)
        } else if (datosCarrito && !pasoParam) {
            const opcionEncontrada2 = listaPasos.find(opcion => opcion.codigo == datosCarrito.pasoCarrito)


            if (volverResumen) {
                const opcionEncontrada = listaPasos.find(opcion => opcion.codigo == 'resumen')
                pasoActualAux = opcionEncontrada
            } else if (!opcionEncontrada2) {
                pasoActualAux = 'datosFacturacion'
            } else {
                pasoActualAux = (opcionEncontrada2)
            }



        }

        setPasoActual(pasoActualAux)









        if (datosCarrito) {
            if (pasoActualAux && pasoActualAux.tipo == 'formulario') {
                const valoresEncontrados = datosCarrito[pasoActualAux.codigoCarrito]

                if (valoresEncontrados) {
                    setValues(valoresEncontrados.values)
                    setValuesConTitulo(valoresEncontrados.valuesConTitulo)
                } else {
                    setValuesConTitulo({})
                    setValues({})
                }

            }

            if (pasoActualAux && pasoActualAux.tipo == 'preguntas') {

                const valoresEncontrados = datosCarrito[pasoActualAux.codigoCarrito]



                if (valoresEncontrados) {

                    setCategorias(valoresEncontrados)
                    setCategoriaSeleccionada(valoresEncontrados[0])
                    setIndiceSeleccionado(0)
                    setObtenerPreguntas(false)
                } else {

                    let cotizadorId = props.match.params.cotizadorId

                    obtenerDatosPreguntas(cotizadorId)
                    setObtenerPreguntas(true)
                }



            }

            if (pasoActualAux && pasoActualAux.tipo == 'coberturas') {



                const valoresEncontrados = datosCarrito[pasoActualAux.codigoCarrito]


                

                obtenerDatosCoberturas(pasoActualAux.urlObtenerCoberturas, datosCarrito.carValorAsegurado)
                

            }

            if (pasoActualAux == 'datosFacturacion') {


                props.history.push({
                    pathname: '/datos-facturacion',
                    search: `?id=${datosCarrito["_id"]["$oid"]}`, //agregar parametros de la url,
                });

            }
        }



        setCargadoData(true)

    }, [pasoParam, listaPasos, datosCarrito])

    const obtenerDatosCoberturas = async (url, valorAsegurado) => {

        if (recargoModificado) {
            setLoading(true)
        }




        const urlAux = `${urlDefaultAux}${controlador}${url}&valorAsegurado=${valorAsegurado}&idcarrito=${idCarrito}&recargo=${recargoSeleccionado || 0}`;





        try {
            const response = await fetch(urlAux)
            const json = await response.json()



            if (json.transaccion) {

                const categoriasModificadas = json.categorias.map(v => ({ ...v, _id: v["_id"]["$oid"] }))


                console.log('valoresEncontrados2', categoriasModificadas)





                setPlanSeleccionado(categoriasModificadas[0])

                setPlanes(categoriasModificadas)


                let nuevaCcoberturas = json.coberturas.map(c => {
                    let cobValor;

                    switch (c.cobValor) {
                        case 'valorasegurado':
                            cobValor = datosCarrito.carValorAsegurado;
                            break;
                        case 'valoraseguradoextras':
                            cobValor = 'valoraseguradoextras';
                            break;
                        case 'valoraseguradomasextras':
                            cobValor = 'valoraseguradomasextras';
                            break;
                        default:
                            cobValor = parseFloat(c.cobValor.replace('$', '').replace('.', ''));
                            break;
                    }

                    if (c.cobValor.includes('|')) {
                        cobValor = parseFloat(datosCarrito.carValorAsegurado) * parseFloat(c.cobValor.split('|').pop()) / 100;
                    }


                    return { ...c, cobValor, catProdCodigo: c.catProdCodigo ? c.catProdCodigo : 'none' };
                });



                setCoberturas(nuevaCcoberturas)

                if (json.productos) {
                    setProductos(json.productos)
                } else {
                    setProductos(
                        [
                            {
                                "prodCodigo": "",
                                "catProdCodigo": "none",
                                "prodNombre": "Coberturas",
                                "prodTitulo": null,
                                "prodLabel": null
                            }
                        ]
                    )
                }


                console.log('nuevaCcoberturas', nuevaCcoberturas)
                setAmparos(json.amparos)






            } else {

            }


        } catch (error) {

        }
        if (recargoModificado) {
            setLoading(false)
            setRecargoModificado(false)
        }

    }

    const obtenerDatosPreguntas = async (cotizadorId) => {


        const urlAux = `${urlPreguntasCotizadorParametrico}${cotizadorId}`;





        try {
            const response = await fetch(urlAux)
            const json = await response.json()
            if (json.transaccion) {
                var categoriasSort = json.categorias.sort((categoria1, categoria2) => { return categoria1.catpregOrden + categoria2.catpregOrden })




                var dateParts = moment(new Date()).format("DD/MM/YYYY").split("/");

                var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

                var preguntasAux = json.preguntas.map(v => (
                    {
                        ...v,

                        value: v.cuesTipo == 'SINO' ? 'no' : v.cuesTipo == 'archivo' ? '' : v.cuesTipo == 'texto' ? '' : v.cuesTipo == 'numerico' ? '' : v.cuesTipo == 'web' ? '' : v.cuesTipo == 'fecha' ? dateObject : v.cuesTipo == 'select' ? null : null,
                        valuesSelect: v.cuesTipo == 'select' ? v.cuesOpcionesTipoSelect.map(w => ({ ...w, value: w.opcion, label: w.opcion })) : null,
                        valuesRadio: v.cuesTipo == 'SINO' ? [
                            {
                                id: 'si', name: 'Si'
                            },
                            {
                                id: 'no', name: 'No'
                            }] : null,

                    }))







                var categoriasAux = categoriasSort.map(v => (
                    {
                        ...v,
                        preguntas: preguntasAux.filter(pregunta => pregunta.cuesCategoria == v["_id"]["$oid"]),
                        validate: false,
                        validation: {},
                        _id: v["_id"]["$oid"],
                    }
                ))




                const categoriasNoVacias = categoriasAux.filter(cat => cat.preguntas.length > 0)





                setCategorias(categoriasNoVacias)
                setCategoriaSeleccionada(categoriasNoVacias[0])
                setIndiceSeleccionado(0)





            } else {

            }


        } catch (error) {

        }

    }

    const consultarRuc = async (ruc, values, tipo, campoModifica, campoBuscador) => {

        setLoading(true)


        const resultado = await apiPost2(urlConsultarIdentificacion, {
            "empresa": empresa,
            "identificador": ruc,
            "tipo": tipo
        })





        if (resultado.transaccion) {
            var objeto = { ...values }
            objeto[campoModifica] = resultado.datosIdentificador[0][campoBuscador];
            objeto['direccion'] = resultado.datosIdentificador[0]['direccion']
            objeto['telefono'] = resultado.datosIdentificador[0]['telefono']
            objeto['email'] = resultado.datosIdentificador[0]['correo']

            var fecha = moment(resultado.datosIdentificador[0]['fechNacimiento'], "DD/MM/YYYY").format('YYYY-MM-DD')

            objeto['fechaNacimiento'] = fecha
            setValues(objeto)
        } else {
            var objeto = { ...values }
            objeto[campoModifica] = '';
            setValues(objeto)
        }



        setLoading(false)
        window.scrollTo(0, 0);
    }


    const comprobarListaNegra = async (identificacion) => {
        let url = urlConsultarListaNegra + identificacion;

        const data = await apiPost(url, {})

        return data
    }




    const guardarInformacion = async (values) => {


        setLoading(true)

        var url = `${urlProcesoCotizadorParametrico}`;
        var body = {
            "empresa": "AIGMETROPOLITANA",
            "plataforma": "WEB",
            "ambiente": "Desarrollo",
            "idAsesor": datosAsesor.cliCodigoCore,
            [pasoActual.codigo]: values,
            "pasoActual": pasoActual.codigo,
            "codigoCotizador": datosCotizador.prodCodigo,
            "idCarrito": idCarrito,
            "objetoAsesor": {
                nombre: `${datosAsesor.nombres} ${datosAsesor.apellidos}`,
                codigoCore: datosAsesor.cliCodigoCore,
                ambiente: ambienteAplicacion,
                emailAsesor: datosAsesor.correo ? datosAsesor.correo : '',
                brokerRUC: datosAsesor.brokerRUC ? datosAsesor.brokerRUC : '',
                brokerNombre: datosAsesor.brokerNombre ? datosAsesor.brokerNombre : '',
                brokerCodigo: datosAsesor.brokerCodigo ? datosAsesor.brokerCodigo : '',
            },
        }

        if (pasoActual.codigo == 'datosCliente') {
            body.nombreAsegurado = values.values.nombreAsegurado
            body.identificacionAsegurado = values.values.identificacion
            body.valorAsegurado = (values.values.valorAsegurado && values.values.valorAsegurado.value) ? values.values.valorAsegurado.value : values.values.valorAsegurado

        }

        if (pasoActual.codigo == 'cargaVidas') {
            body['vidas'] = values

        }


        console.log('pasoActual', pasoActual, body)

        try {
            const response = await fetch(url, { body: JSON.stringify(body), method: 'POST' })
            const json = await response.json()

            if (json.transaccion) {

                if (json.urlSiguiente == '/datos-facturacion') {

                    props.history.push({
                        pathname: json.urlSiguiente,
                        search: `?id=${json.idCarrito}`, //agregar parametros de la url,
                    });

                } else {



                    if (!values.calcular) {
                        props.history.push({
                            pathname: json.siguienteUrl,
                            search: `?id=${json.idCarrito}&paso=${json.siguientePaso}`, //agregar parametros de la url,
                        });

                        setPasoParam(null)
                        setIdCarrito(json.idCarrito)
                        setPasoParam(json.siguientePaso)
                        obtenerDatosCotizador(json.siguientePaso, idCarrito)

                    } else {
                     //   setFormEditado(false)
                        obtenerInformacionCarrito()
                    }




                    setPasoParam(null)
                    setIdCarrito(json.idCarrito)
                    setPasoParam(json.siguientePaso)
                    obtenerDatosCotizador(json.siguientePaso, idCarrito)

                }


            }


            setLoading(false)
        } catch (error) {

            setLoading(false)
        }
    }

    const obtenerInformacionCarrito = async () => {
        setCargadoData(false)

        var url = `${urlRecuperarCotizadorParametrico}${idCarrito}`;



        try {
            const response = await fetch(url, { method: 'GET' })
            const json = await response.json()

            if (json.transaccion) {

                setCarritoActual(json)

                setCargadoData(true)

                setDatosCarrito(json.carrito)

                if (json.carrito && json.carrito.carCoberturas && json.carrito.carCoberturas.requiereRecargos) {
                    setRequiereRecargos(json.carrito.carCoberturas.requiereRecargos)
                    setRecargoSeleccionado(json.carrito.carCoberturas.recargo)

                }

                if (json.carrito && json.carrito.carCoberturas && json.carrito.carCoberturas.categorias) {



                    setPlanes(json.carrito.carCoberturas.categorias)
                }


                if (json.carrito && json.carrito.carCoberturas && json.carrito.carCoberturas.coberturas) {

                    setCoberturas(json.carrito.carCoberturas.coberturas)
                }

                if (json.carrito && json.carrito.carResumen && json.carrito.carResumen.requiereObservacion) {
                    setRequiereObservacion(json.carrito.carResumen.requiereObservacion)
                    setObservacion(json.carrito.carResumen.observacion)
                    setObservacionValida(true)

                }

                console.log('json.carrito', json.carrito)
            }

        } catch (error) {

        }
    }

    const onClickRegresar = () => {
        props.history.push({
            pathname: pasoActual.urlRegresar,
            search: `?id=${idCarrito}&paso=${pasoActual.pasoRegresar}`, //agregar parametros de la url,
        });


        setPasoParam(null)
        setIdCarrito(idCarrito)
        setPasoParam(pasoActual.pasoRegresar)
        obtenerDatosCotizador(pasoActual.pasoRegresar, idCarrito)

    }


    const obtenerDatosCotizador = async () => {



        let cotizadorId = props.match.params.cotizadorId


        if (cotizadorId) {


            setLoading(true)


            var url = urlObtenerInformacionInicialCP.replace("{{empresa}}", empresa).replace('{{codigoCotizador}}', cotizadorId);

            try {
                const response = await fetch(url)
                const json = await response.json()
                if (json.transaccion) {
                    console.log('json1212', json.cotizador)

                    setAplicaRecargos(json.cotizador.aplicaRecargo)
                    setAplicaObservaciones(json.cotizador.aplicaObservaciones)
                    setRequiereObservacionObligatoria(json.cotizador.requiereObservacionObligatoria ? true : false);
                    setMensajeObservacion(json.cotizador.prodDetalleMensajeInformativo)
                    setAplicaControlDuplicidad(json.cotizador.aplicaDuplicidadProducto)
                    setRecargos(json.cotizador.recargos)
                    setListaPasos(json.pasoscotizador.listaPasos)
                    setRequiereEmisionRetroactiva(json.cotizador.prodEmisionRetroactiva ? true : false)
                    setRamoNombre(json.cotizador.prodNombre ? json.cotizador.prodNombre : '')
                    setRamoCodigo(json.cotizador.prodCodigo ? json.cotizador.prodCodigo : '')
                    setListaOpciones(json.pasoscotizador.listaOpciones)
                    setDatosCotizador({ ...json.cotizador, ...json.pasoscotizador })
                    setTieneError(false)
                    setErrorMensaje('')


                } else {
                    setTieneError(true)
                    setErrorMensaje(json.mensajeError)
                }
                setLoading(false)


            } catch (error) {
                setLoading(false)
            }

            window.scrollTo(0, 0);

        } else {

        }



    }

    const renderSwitch = (pasoActual) => {
        let cotizadorId = props.match.params.cotizadorId


        switch (pasoActual.tipo) {
            case 'formulario':
                return (
                    <ComponentFormularioParametrico
                        mensajeListaNegra={mensajeListaNegra}
                        bloqueoListaNegra={bloqueoListaNegra}
                        codigoFormulario={pasoActual.codigoFormualario}
                        urlSiguiente={pasoActual.urlSiguiente}
                        history={props.history}
                        paso={pasoActual.codigo}
                        loading={loading}
                        setLoading={(data) => { }}
                        guardarInformacion={(data) => guardarInformacion(data)}
                        values={values}



                        onSubmit={async (values, tieneErrores, errores, valuesConTitulo) => {







                            if (!tieneErrores) {

                                const listaNegra = await comprobarListaNegra(values.identificacion)


                                if (listaNegra.transaccion) {

                                    setBloqueoListaNegra(false)
                                    setMensajeListaNegra('')

                                    guardarInformacion({ values: values, valuesConTitulo: valuesConTitulo })
                                    /*     history.push({
                                            pathname: urlSiguiente,
                                            search: `?id=${'adas123123'}`,
                                        }); */
                                } else {
                                    setBloqueoListaNegra(true)
                                    setMensajeListaNegra(listaNegra.mensaje)
                                }





                            }

                        }}
                        setValues={(key, values) => {

                            setValues(values)



                            if (key == 'identificacion') {
                                if (values[key].length == 13 && values.tipoIdentificacion.value == "2") {
                                    consultarRuc(values.identificacion, values, 'ruc', 'nombreAsegurado', 'nombre')
                                }

                                if (values[key].length == 10 && values.tipoIdentificacion.value == "1") {
                                    consultarRuc(values.identificacion, values, 'cedula', 'nombreAsegurado', 'nombre')
                                }
                            }
                        }

                        }
                        setValuesInicial={(valores) => {
                            if (valores) {
                                setValues(valores)
                            }

                        }}
                        valuesConTitulo={valuesConTitulo}
                        setValuesConTitulo={(values) => {


                            setValuesConTitulo(values)
                        }}
                    />
                );
            case 'coberturas':
                return (
                    datosCarrito &&
                    <ComponentCoberturasParametrico
                        urlCoberturas={pasoActual.urlObtenerCoberturas}
                        planSeleccionado={planSeleccionado}
                        setPlanSeleccionado={(valor) => {
                            setPlanSeleccionado(valor)

                        }}
                        datosCarrito={datosCarrito}
                        setLoading={(data) => { }}
                        guardarInformacion={(data) => guardarInformacion(data)}
                        onRegresar={() => onClickRegresar()}
                        planes={planes}
                        coberturas={coberturas}
                        productos={productos}
                        amparos={amparos}
                        setPlanes={(value) => setPlanes(value)}
                        setCoberturas={(value) => setCoberturas(value)}
                        setProductos={(value) => setProductos(value)}
                        aplicaRecargos={aplicaRecargos}
                        aplicaObservaciones={aplicaObservaciones}
                        mensajeRecargos={mensajeRecargos}
                        requiereRecargos={requiereRecargos}
                        setRequiereRecargos={(valor) => { setRequiereRecargos(valor) }}
                        recargoSeleccionado={recargoSeleccionado}
                        setRecargoSeleccionado={(valor) => { setRecargoSeleccionado(valor) }}
                        recargos={recargos}
                        recargoModificado={recargoModificado}
                        setRecargoModificado={(value) => { setRecargoModificado(value) }}
                        recalcularCoberturas={() => obtenerDatosCoberturas(pasoActual.urlObtenerCoberturas, datosCarrito.carValorAsegurado)}
                        requiereObservacion={requiereObservacion}
                        setRequiereObservacion={(valor) => { setRequiereObservacion(valor) }}
                        observacion={observacion}
                        setObservacion={(value) => { setObservacion(value) }}

                    />
                );
            case 'resumen':
                return (
                    datosCarrito &&
                    <ComponentResumenParametrico

                        datosContratanteAux={datosCarrito.carDatosCliente.valuesConTitulo}
                        datosSeleccionadosAux={datosCarrito.carDatosBien ? datosCarrito.carDatosBien.valuesConTitulo : null}
                        preguntas={datosCarrito.carPreguntas}
                        planSeleccionado={datosCarrito.carCoberturas && datosCarrito.carCoberturas.planSeleccionado && datosCarrito.carCoberturas.planSeleccionado.catNombre}
                        onRegresar={() => onClickRegresar()}
                        datosCarrito={datosCarrito}
                        loading={loading}
                        ramoNombre={ramoCodigo}
                        guardarInformacion={(data) => guardarInformacion(data)}
                        setLoading={(valor) => { setLoading(valor) }}
                        duplicado={duplicado}
                        setDuplicado={(valor) => { setDuplicado(valor) }}
                        mensajeDuplicado={mensajeDuplicado}
                        setMensajeDuplicado={(valor) => { setMensajeDuplicado(valor) }}
                        history={props.history}
                        cotizadorId={cotizadorId}
                        requiereEmisionRetroactiva={requiereEmisionRetroactiva}
                        aplicaRecargos={aplicaRecargos}
                        aplicaObservaciones={aplicaObservaciones}
                        mensajeRecargos={mensajeRecargos}
                        requiereRecargos={requiereRecargos}
                        setRequiereRecargos={(valor) => { setRequiereRecargos(valor) }}
                        recargoSeleccionado={recargoSeleccionado}
                        setRecargoSeleccionado={(valor) => { setRecargoSeleccionado(valor) }}
                        recargos={recargos}
                        recargoModificado={recargoModificado}
                        setRecargoModificado={(value) => { setRecargoModificado(value) }}
                        recalcularCoberturas={() => obtenerDatosCoberturas(pasoActual.urlObtenerCoberturas, datosCarrito.carValorAsegurado)}
                        mensajeObservaciones={mensajeObservaciones}
                        requiereObservacion={requiereObservacion}
                        setRequiereObservacion={(valor) => { setRequiereObservacion(valor) }}
                        observacion={observacion}
                        setObservacion={(value) => { setObservacion(value) }}
                        observacionValida={observacionValida}
                        setObservacionValida={(value) => { setObservacionValida(value) }}
                        mensajeObservacion={mensajeObservacion}
                        requiereObservacionObligatoria={requiereObservacionObligatoria}

                    />
                );
            case 'preguntas':
                return (

                    ((obtenerPreguntas == true || obtenerPreguntas == false) && cargadoData && datosCarrito) ?
                        <ComponentPreguntasParametrico
                            id={Math.random()}
                            urlPreguntas={pasoActual.urlObtenerPreguntas}
                            aplicaControlDuplicidad={aplicaControlDuplicidad}
                            placaDuplicada={placaDuplicada}
                            setPlacaDuplicada={(valor) => { setPlacaDuplicada(valor) }}
                            mensajeDuplicado={mensajeDuplicado}
                            setMensajeDuplicado={(valor) => { setMensajeDuplicado(valor) }}
                            setLoading={(data) => { setLoading(data) }}
                            datosCarrito={datosCarrito}
                            guardarInformacion={(data) => guardarInformacion(data)}
                            onRegresar={() => onClickRegresar()}
                            categorias={categorias}
                            setCategorias={(value) => { setPreguntas(value) }}
                            categoriaSeleccionada={categoriaSeleccionada}
                            setCategoriaSeleccionada={(value) => { setCategoriaSeleccionada(value) }}
                            setIndiceSeleccionado={(value) => setIndiceSeleccionado(value)}
                            obtenerPreguntas={obtenerPreguntas}
                            cotizadorId={cotizadorId}
                            indiceSeleccionado={indiceSeleccionado}
                        /> : null
                );
            default:
                return <div>Paso no encontrado</div>;
        }
    }



    return (

        <LoadingScreen
            loading={loading}
            bgColor="#f1f1f1"
            spinnerColor="#001871"
            textColor="#676767"
            logoSrc={logo}
            text="Cargando..."
        >
            <main className="cr-app bg-light">
                <div className="cr-content container-fluid">
                    <div className="container-body-spaces">





                        {(datosCotizador) ?
                            <Page
                                title={datosCotizador.prodNombre}
                                breadcrumbs={[{ name: datosCotizador.prodNombre, active: true }]}
                            >
                                <Row>
                                    <Col lg={8} md={12} sm={12} xs={12}>
                                        <Steps tipo={'parametrico'} listaOpciones={listaOpciones} paso={pasoParam}></Steps>

                                    </Col>
                                </Row>



                                {pasoActual && pasoActual.tipo && renderSwitch(pasoActual)}
                                {
                                    pasoActual &&
                                    pasoActual.tipo &&
                                    pasoActual.pasoRegresar && pasoActual.tipo == 'formulario' &&
                                    <div>

                                        <Row>
                                            <Col lg={8} md={12} sm={12} xs={12} className="div-align-center">
                                                <Card>
                                                    <CardBody>

                                                        <Button
                                                            onClick={() => {

                                                                onClickRegresar()

                                                            }}
                                                            className="btn btn-purple btn btn-secondary"
                                                            style={{ marginLeft: "5px" }}
                                                        >
                                                            <i class="fa fa-chevron-circle-left" aria-hidden="true" />
                                                            &nbsp;REGRESAR
                                                        </Button>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        </Row>



                                    </div>
                                }
                            </Page> : null
                        }

                        {tieneError &&
                            <Alert
                                color="danger"
                                isOpen={(tieneError)}
                                style={{ marginTop: 20 }}

                            >
                                <center>
                                    <p>
                                        {errorMensaje}
                                    </p>
                                </center>
                            </Alert>}



                    </div>
                </div>
            </main>
        </LoadingScreen>


    );
};
export default ContainerCotizadorParametrico;
